import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDuration',
})
export class FormatDurationPipe implements PipeTransform {
  transform(value: any, inputFormat: any, outputFormat: any): any {
    let days: any;
    let seconds: any;
    let minutes: any;
    let hours: any;

    let negative = false;
    if (value < 0) {
      negative = true;
      value = value * -1;
    }
    if (
      inputFormat === 'ms' &&
      (outputFormat === 'hh:mm:ss' || outputFormat === 'h:mm:ss')
    ) {
      seconds = Math.floor((value / 1000) % 60);
      minutes = Math.floor((value / (1000 * 60)) % 60);
      hours = Math.floor(value / (1000 * 60 * 60));
      return this.format(outputFormat, seconds, minutes, hours, days, negative);
    } else if (
      inputFormat === 's' &&
      (outputFormat === 'hh:mm:ss' || outputFormat === 'h:mm:ss')
    ) {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor(value / 60 / 60);
      return this.format(outputFormat, seconds, minutes, hours, days, negative);
    } else if (
      inputFormat === 's' &&
      (outputFormat === 'mm:ss' || outputFormat === 'm:ss')
    ) {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor(value / 60 / 60);
      minutes = minutes + hours;
      return this.format(outputFormat, seconds, minutes, hours, days, negative);
    } else if (
      inputFormat === 'ms' &&
      (outputFormat === 'd:h:m:ss' ||
        outputFormat === 'd:h:m:ss:Long' ||
        outputFormat === 'd:h:m:ss:LongSmart')
    ) {
      seconds = Math.floor((value / 1000) % 60);
      minutes = Math.floor((value / (1000 * 60)) % 60);
      hours = Math.floor((value / (1000 * 60 * 60)) % 24);
      days = Math.floor(value / (1000 * 60 * 60 * 24));
      return this.format(outputFormat, seconds, minutes, hours, days, negative);
    } else if (
      inputFormat === 's' &&
      (outputFormat === 'd:h:m:ss' ||
        outputFormat === 'd:h:m:ss:Long' ||
        outputFormat === 'd:h:m:ss:LongSmart' ||
        outputFormat === 'd:h:m:ss:LongSmartNoZero')
    ) {
      seconds = Math.floor(value % 60);
      minutes = Math.floor((value / 60) % 60);
      hours = Math.floor((value / 60 / 60) % 24);
      days = Math.floor(value / 60 / 60 / 24);
      return this.format(outputFormat, seconds, minutes, hours, days, negative);
    } else {
      return value;
    }
  }

  private format(
    outputFormat: any,
    seconds: any,
    minutes: any,
    hours: any,
    days: any,
    negative: boolean
  ) {
    // days < 10  ? (days = '0' + days) : days;
    hours < 10 && outputFormat == 'hh:mm:ss' ? (hours = '0' + hours) : hours;
    minutes < 10 &&
    (outputFormat == 'hh:mm:ss' ||
      outputFormat == 'mm:ss' ||
      outputFormat == 'h:mm:ss' ||
      outputFormat == 'd:h:m:ss:Long' ||
      outputFormat == 'd:h:m:ss:LongSmart')
      ? (minutes = '0' + minutes)
      : minutes;

    seconds < 10 &&
    (outputFormat == 'hh:mm:ss' ||
      outputFormat == 'mm:ss' ||
      outputFormat == 'h:mm:ss' ||
      outputFormat == 'd:h:m:ss:Long' ||
      outputFormat == 'd:h:m:ss:LongSmart')
      ? (seconds = '0' + seconds)
      : seconds;
    //seconds < 10 ? (seconds = '0' + seconds) : seconds;

    let pre = '';
    if (negative) {
      pre = '-';
    }
    switch (outputFormat) {
      default:
      case 'm:ss':
      case 'mm:ss':
        return pre + `${minutes}:${seconds}`;
      case 'hh:mm:ss':
      case 'h:mm:ss':
        return pre + `${hours}:${minutes}:${seconds}`;

      case 'd:h:m:ss':
        return pre + `${days}d, ${hours}h, ${minutes}m, ${seconds}s`;

      case 'd:h:m:ss:Long':
        return (
          pre +
          `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`
        );

      case 'd:h:m:ss:LongSmart':
        return (
          pre +
          ((days ? days + 'd ' : '') +
            (hours ? hours + 'h ' : '') +
            (minutes ? minutes + 'm ' : '') +
            (seconds!=undefined ? seconds + 's ' : ''))
        );
      case 'd:h:m:ss:LongSmartNoZero':
        return (
          pre +
          ((days ? days + 'd ' : '') +
            (hours ? hours + 'h ' : '') +
            (minutes ? minutes + 'm ' : '') +
            (seconds!=undefined ? seconds + 's ' : ''))
        );
    }
  }
}
